import React, {useState} from 'react';
import useGetfarmProducts from './hooks/useGetfarmProducts';
import Products from './products';
import SearchInput from 'components/searchInput';
import {searchTree} from './helper/searchTreeHelper';
import SearchedProducts from './searchedProducts';
import useDebounce from 'utilities/hooks/debounce/useDebounce';
import DotsLoading from 'components/loadings/dotsLoading';

const Purchase = () => {
  const [search, setSearch] = useState('');
  const {farmProductsData, farmProductsIsloading} = useGetfarmProducts();

  const searchValue = useDebounce(search, 500);

  return (
    <>
      <h2 className="w-full flex text-[18px] font-normal">
        انتخاب دسته بندی محصول
      </h2>
      <div className="flex flex-col items-center  w-full h-[95%] justify-center gap-4">
        <div className="h-[10%] flex w-full justify-center sticky top-0 bg-gray-10 rounded-lg py-2">
          <SearchInput Search={search} setSearch={setSearch} />
        </div>
        {farmProductsIsloading ? (
          <DotsLoading />
        ) : (
          <>
            {search ? (
              <SearchedProducts
                subProducts={
                  searchTree(searchValue, farmProductsData).subProducts
                }
                products={searchTree(searchValue, farmProductsData).products}
              />
            ) : (
              <Products products={farmProductsData} />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Purchase;
